"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuccessResponse = function (result) { return ({
    Success: true,
    HttpStatus: 200,
    HttpStatusText: 'Ok',
    Message: undefined,
    Result: result
}); };
//# sourceMappingURL=response.js.map